/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangePasswordRequestModel } from '../../models/change-password-request-model';

export interface LocalAccountChangePasswordPost$Params {
  
    /**
     * Change password request model containing new password
     */
    body?: ChangePasswordRequestModel
}

export function localAccountChangePasswordPost(http: HttpClient, rootUrl: string, params?: LocalAccountChangePasswordPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, localAccountChangePasswordPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as AuthenticationStrictHttpResponse<void>;
    })
  );
}

localAccountChangePasswordPost.PATH = '/LocalAccount/ChangePassword';
